import { PapRequestStatusPossibility, supportsChange } from '@app/pcs/models';
import * as R from 'ramda';

type FilterStatusesThatSupportChange = (statuses: PapRequestStatusPossibility[]) => PapRequestStatusPossibility[];
export const filterStatusesThatSupportChange: FilterStatusesThatSupportChange = R.filter(supportsChange);

const byGroup = R.eqProps('group');

type GroupByStatusGroup = (statuses: PapRequestStatusPossibility[]) => PapRequestStatusPossibility[][];
export const groupByStatusGroup: GroupByStatusGroup = R.groupWith(byGroup);
